/**
 * Filtros de fecha de Consultas (Utilidad, Cuentas CT, Cuadre del día; UTL-22..24, Mario 4-nov: «el filtro de fecha no funciona… trae como solo un día»).
 * Al teclear una fecha el campo queda vacío o incompleto (el 31 de noviembre no existe; el año se escribe de a un dígito: 0002, 0020, 0202, 2026) y el
 * navegador avisa igual. Mandar ese extremo vacío es pedir «un solo día» al núcleo (UTL-01), así que aquí se valida: sin las dos fechas completas no se consulta.
 * Sin dependencias (lógica pura, se prueba sola).
 */
const AÑO_MINIMO = 2000;

/** Un día AAAA-MM-DD que existe y con año de cuatro dígitos razonable (no el 0002 del tecleo a medias). */
export const esDia = (s: unknown): boolean => {
  if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s) || Number(s.slice(0, 4)) < AÑO_MINIMO) return false;
  const t = Date.parse(`${s}T00:00:00Z`);
  return !isNaN(t) && new Date(t).toISOString().slice(0, 10) === s;
};

export interface RangoAcomodado { ok: boolean; desde: string; hasta: string; aviso: string }

/**
 * Lo que se hace al cambiar `cual` extremo: si falta una fecha completa no se consulta (se deja lo escrito y se avisa); si «desde» pasa a «hasta» (o al revés)
 * el otro extremo sigue al que se movió; con `tope`, «hasta» no pasa de él.
 */
export function acomodarRango(f: { desde: string; hasta: string }, cual: 'desde' | 'hasta', tope?: string): RangoAcomodado {
  let { desde, hasta } = f;
  if (!esDia(desde) || !esDia(hasta)) return { ok: false, desde, hasta, aviso: 'Completa las dos fechas (día, mes y año) para consultar.' };
  if (tope && esDia(tope) && hasta > tope) hasta = tope;
  if (desde > hasta) { if (cual === 'desde') hasta = desde; else desde = hasta; }
  if (tope && esDia(tope) && desde > tope) desde = tope;
  return { ok: true, desde, hasta, aviso: '' };
}

/**
 * Solo vale la última petición: `nuevo()` cancela la anterior (`alCancelar`, que corta la petición HTTP) y da su número; la respuesta que llega con un
 * número que ya no es el vigente se descarta. Un día en vivo tarda minutos: la vieja puede llegar mucho después de la nueva.
 */
export class UltimaRespuesta {
  private n = 0;
  constructor(private alCancelar: () => void = () => { }) { }
  nuevo(): number { this.alCancelar(); return ++this.n; }
  vigente(n: number): boolean { return n === this.n; }
  cancelarTodo(): void { this.n++; this.alCancelar(); }
}

/** Junta varios cambios seguidos en una sola ejecución (la última), para no consultar con cada dígito del año. */
export class Aplazador {
  private t: any = null;
  en(ms: number, fn: () => void): void { this.cancelar(); this.t = setTimeout(() => { this.t = null; fn(); }, ms); }
  cancelar(): void { if (this.t) { clearTimeout(this.t); this.t = null; } }
}
